<template>
  <div class="doc-root">
    <div class="nav-bar-background"></div>

    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div
            class="navbar-light navbar-expand-md bs-sidebar hidden-print affix"
            role="complementary"
          >
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggler collapsed"
                data-toggle="collapse"
                data-target="#toc-collapse"
                title="Table of Contents"
                @click="handleClick"
              >
                <i class="iconfont icon-xiangxiajiantou"></i>
              </button>
            </div>
            <div
              id="toc-collapse"
              class="navbar-collapse collapse card bg-secondary"
              :class="{ show: isShow }"
            >
              <ul class="nav flex-column">
                <li class="nav-item" data-level="2">
                  <a href="#_1" class="nav-link">1. 新项目接入Tako</a>
                  <ul class="nav flex-column"></ul>
                </li>
                <li class="nav-item" data-level="2">
                  <a href="#_2" class="nav-link">2. 上传应用</a>
                  <ul class="nav flex-column"></ul>
                </li>
                <li class="nav-item" data-level="2">
                  <a href="#_3" class="nav-link">3. 更新包信息</a>
                  <ul class="nav flex-column"></ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-9" role="main">
          <h2 id="_1">1. 新项目接入Tako</h2>
          <p>请联系匡乐(kuangle)或邓跨东(dengkuadong)。</p>

          <h2 id="_2">2. 上传应用</h2>
          <p>
            用于项目自动构建后上传包到Tako服务器（或利用质量中心的云构建Tako插件上传）。上传命令：
          </p>
          <pre><code class="bash">curl -F &quot;uploadfile=@name.apk&quot; -F &quot;uploadkey={Upload key}&quot; -F &quot;lan=true&quot; -F &quot;cloud=false&quot; \
    http://10.11.8.109:33388/upload</code></pre>

          <p>
            上传成功后将返回当前版本的<code>versionid</code>，针对该版本的其它操作会用到此id（好比：自动下载包和更新包信息）。
          </p>
          <p><strong>相关参数说明： </strong></p>
          <table>
            <thead>
              <tr>
                <th align="left">参数</th>
                <th align="left">说明</th>
                <th align="center">是否必须</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="left">uploadkey</td>
                <td align="left">
                  上传凭证用于校验合法性（请填写应用uploadkey）
                </td>
                <td align="center">是</td>
              </tr>
              <tr>
                <td align="left">lan</td>
                <td align="left">是否上传内网存储，默认为<code>false</code></td>
                <td align="center">-</td>
              </tr>
              <tr>
                <td align="left">cloud</td>
                <td align="left">
                  是否上传外网云存储，默认为<code>false</code>
                </td>
                <td align="center">-</td>
              </tr>
              <tr>
                <td align="left">resign</td>
                <td align="left">ipa 包是否重签名，默认为<code>false</code></td>
                <td align="center">-</td>
              </tr>
              <tr>
                <td align="left">releasenote</td>
                <td align="left">当前上传应用版本的简要更新说明</td>
                <td align="center">-</td>
              </tr>
            </tbody>
          </table>

          <h2 id="_3">3. 更新包信息</h2>
          <p><strong> POST </strong></p>
          <pre><code class="bash">https://tako.im/service/app/version/extra?id=&lt;versionid&gt;</code></pre>
          <p><strong> Body raw(json) </strong></p>
          <pre><code class="json">{
    &quot;log&quot;: &quot;1.修复BUG 2020041242\n2.修复BUG 202005011432\n3.新增一键切换功能&quot;,
    &quot;tags&quot;: [&quot;tvb&quot;, &quot;release&quot;],
    &quot;developers&quot;: [&quot;wangjun5&quot;, &quot;xiaobai&quot;],
    &quot;uploadkey&quot;: &quot;xxx&quot;
}</code></pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import * as hljs from "./Doc/Highlight.pack.js";

const isShow = ref(false);
function handleClick() {
  isShow.value = !isShow.value;
}

const $ = window.$;

onMounted(() => {
  hljs.initHighlighting();
  main();
});

function applyTopPadding() {
  // Update various absolute positions to match where the main container
  // starts. This is necessary for handling multi-line nav headers, since
  // that pushes the main container down.
  var offset = $(".doc-root > .container").offset();
  $(".doc-root").css("scroll-padding-top", offset.top + "px");
  $(".bs-sidebar.affix").css("top", offset.top + "px");
}

function main() {
  $(".doc-root").on("resize", applyTopPadding);
  /* Prevent disabled links from causing a page reload */
  $("li.disabled a").click(function () {
    event.preventDefault();
  });

  applyTopPadding();
  $("table").addClass("table table-striped table-hover");

  // Improve the scrollspy behaviour when users click on a TOC item.
  $(".bs-sidenav a").on("click", function () {
    var clicked = this;
    setTimeout(function () {
      var active = $(".nav li.active a");
      active = active[active.length - 1];
      if (clicked !== active) {
        $(active).parent().removeClass("active");
        $(clicked).parent().addClass("active");
      }
    }, 50);
  });

  function showInnerDropdown(item) {
    var popup = $(item).next(".dropdown-menu");
    popup.addClass("show");
    $(item).addClass("open");

    // First, close any sibling dropdowns.
    var container = $(item).parent().parent();
    container.find("> .dropdown-submenu > a").each(function (i, el) {
      if (el !== item) {
        hideInnerDropdown(el);
      }
    });

    var popupMargin = 10;
    var maxBottom = $(".doc-root").height() - popupMargin;
    var bounds = item.getBoundingClientRect();

    popup.css("left", bounds.right + "px");
    if (
      bounds.top + popup.height() > maxBottom &&
      bounds.top > $(".doc-root").height() / 2
    ) {
      popup.css({
        top: bounds.bottom - popup.height() + "px",
        "max-height": bounds.bottom - popupMargin + "px",
      });
    } else {
      popup.css({
        top: bounds.top + "px",
        "max-height": maxBottom - bounds.top + "px",
      });
    }
  }

  function hideInnerDropdown(item) {
    var popup = $(item).next(".dropdown-menu");
    popup.removeClass("show");
    $(item).removeClass("open");

    popup.scrollTop(0);
    popup.find(".dropdown-menu").scrollTop(0).removeClass("show");
    popup.find(".dropdown-submenu > a").removeClass("open");
  }

  $(".dropdown-submenu > a").on("click", function (e) {
    if ($(this).next(".dropdown-menu").hasClass("show")) {
      hideInnerDropdown(this);
    } else {
      showInnerDropdown(this);
    }

    e.stopPropagation();
    e.preventDefault();
  });

  $(".dropdown-menu")
    .parent()
    .on("hide.bs.dropdown", function (e) {
      $(this).find(".dropdown-menu").scrollTop(0);
      $(this).find(".dropdown-submenu > a").removeClass("open");
      $(this).find(".dropdown-menu .dropdown-menu").removeClass("show");
    });
}
</script>

<style src="@/Assets/Css/bootstrap.min.css" scoped></style>
<style lang="scss" scoped>
/*
Original highlight.js style (c) Ivan Sagalaev <maniac@softwaremaniacs.org>
*/

.hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  background: #f0f0f0;
}

/* Base color: saturation 0; */

.hljs,
.hljs-subst {
  color: #444;
}

.hljs :deep() {
  .hljs-comment {
    color: #888888;
  }

  .hljs-keyword,
  .hljs-attribute,
  .hljs-selector-tag,
  .hljs-meta-keyword,
  .hljs-doctag,
  .hljs-name {
    font-weight: bold;
  }

  /* User color: hue: 0 */

  .hljs-type,
  .hljs-string,
  .hljs-number,
  .hljs-selector-id,
  .hljs-selector-class,
  .hljs-quote,
  .hljs-template-tag,
  .hljs-deletion {
    color: #880000;
  }

  .hljs-title,
  .hljs-section {
    color: #880000;
    font-weight: bold;
  }

  .hljs-regexp,
  .hljs-symbol,
  .hljs-variable,
  .hljs-template-variable,
  .hljs-link,
  .hljs-selector-attr,
  .hljs-selector-pseudo {
    color: #bc6060;
  }

  /* Language color: hue: 90; */

  .hljs-literal {
    color: #78a960;
  }

  .hljs-built_in,
  .hljs-bullet,
  .hljs-code,
  .hljs-addition {
    color: #397300;
  }

  /* Meta color: hue: 200 */

  .hljs-meta {
    color: #1f7199;
  }

  .hljs-meta-string {
    color: #4d99bf;
  }

  /* Misc effects */

  .hljs-emphasis {
    font-style: italic;
  }

  .hljs-strong {
    font-weight: bold;
  }
}
</style>
<style lang="scss" scoped>
.doc-root {
  /* csslint ignore:start */
  /* The nav header is 3.5rem high, plus 20px for the margin-top of the
       main container. */
  scroll-padding-top: calc(3.5rem + 20px);
  /* csslint ignore:end */
}

/* Replacement for `body { background-attachment: fixed; }`, which has
   performance issues when scrolling on large displays. See #1394. */
.doc-root::before {
  content: " ";
  position: fixed;
  width: 100%;
  height: 100%;
  top: 50px;
  left: 0;
  background-color: #f8f8f8;
  background: url(/assets/images/grid.png) repeat-x;
  will-change: transform;
  z-index: -1;
}

.nav-bar-background {
  height: 50px;
  margin-bottom: 20px;
  background-color: #21252b;
}

.col-md-9 img {
  max-width: 100%;
  display: inline-block;
  padding: 4px;
  line-height: 1.428571429;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 20px auto 30px auto;
}

h1 {
  color: #444;
  font-weight: 400;
  font-size: 42px;
}

h2,
h3,
h4,
h5,
h6 {
  color: #444;
  font-weight: 300;
}

/*
 * Side navigation
 *
 * Scrollspy and affixed enhanced navigation to highlight sections and secondary
 * sections of docs content.
 */

.bs-sidebar.affix {
  /* csslint allow: adjoining-classes */
  /* csslint ignore:start */
  position: -webkit-sticky;
  position: sticky;
  /* csslint ignore:end */
  /* The nav header is 3.5rem high, plus 20px for the margin-top of the
       main container. */
  top: calc(3.5rem + 20px);
}

.bs-sidebar.card {
  /* csslint allow: adjoining-classes */
  padding: 0;
  max-height: 90%;
  overflow-y: auto;
}

/* Toggle (vertically flip) sidebar collapse icon */
.bs-sidebar .navbar-toggler span {
  -moz-transform: scale(1, -1);
  -webkit-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}

.bs-sidebar .navbar-toggler.collapsed span {
  /* csslint allow: adjoining-classes */
  -moz-transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  -o-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  transform: scale(1, 1);
}

/* First level of nav */
.bs-sidebar > .navbar-collapse > .nav {
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
  width: 100%;
}

/* All levels of nav */
.bs-sidebar .nav > li > a {
  display: block;
  padding: 5px 20px;
  z-index: 1;
}
.bs-sidebar .nav > li > a:hover,
.bs-sidebar .nav > li > a:focus {
  text-decoration: none;
  border-right: 1px solid;
}
.bs-sidebar .nav > li > a.active,
.bs-sidebar .nav > li > a.active:hover,
.bs-sidebar .nav > li > a.active:focus {
  font-weight: bold;
  background-color: transparent;
  border-right: 1px solid;
}

.bs-sidebar .nav .nav .nav {
  margin-left: 1em;
}

.bs-sidebar .nav > li > a {
  font-weight: bold;
}

.bs-sidebar .nav .nav > li > a {
  font-weight: normal;
}

@media (max-width: 991.98px) {
  .navbar-collapse.show {
    /* csslint allow: adjoining-classes */
    overflow-y: auto;
    max-height: calc(100vh - 3.5rem);
  }
}

.dropdown-submenu > .dropdown-menu {
  margin: 0 0 0 1.5rem;
  padding: 0;
  border-width: 0;
}

.dropdown-submenu > a::after {
  display: block;
  content: " ";
  float: right;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px 0 5px 5px;
  border-left-color: #ccc;
  margin-top: 5px;
  margin-right: -10px;
}

.dropdown-submenu:hover > a::after {
  border-left-color: #fff;
}

@media (min-width: 992px) {
  .dropdown-menu {
    overflow-y: auto;
    max-height: calc(100vh - 3.5rem);
  }

  .dropdown-submenu {
    position: relative;
  }

  .dropdown-submenu > .dropdown-menu {
    /* csslint ignore:start */
    position: fixed !important;
    /* csslint ignore:end */
    margin-top: -9px;
    margin-left: -2px;
    border-width: 1px;
    padding: 0.5rem 0;
  }

  .dropdown-submenu.pull-left {
    /* csslint allow: adjoining-classes */
    float: none;
  }

  .dropdown-submenu.pull-left > .dropdown-menu {
    /* csslint allow: adjoining-classes */
    left: -100%;
    margin-left: 10px;
  }
}
</style>
